// src/components/YearRangeSlider.js

import React from "react";
import PropTypes from "prop-types";
import { Range, getTrackBackground } from "react-range";
import "../styles/LayerItem.css"; // Reuse existing CSS for consistency

const YearRangeSlider = ({
  values,
  step,
  min,
  max,
  onChange,
  renderThumbContent,
  showPin, // New prop to control pin visibility
}) => {
  return (
    <Range
      values={values}
      step={step}
      min={min}
      max={max}
      onChange={onChange}
      renderTrack={({ props, children }) => (
        <div
          {...props}
          style={{
            ...props.style,
            height: "2px",
            background: getTrackBackground({
              values,
              colors: ["#ccc", "#808080", "#ccc"],
              min,
              max,
            }),
            borderRadius: "3px",
            margin: "10px 0",
          }}
          ref={props.ref}
        >
          {children}
        </div>
      )}
      renderThumb={({ index, props }) => (
        <div
          {...props}
          className="v-slider__thumb-label pin-thumb" // Use existing class names
          style={{ cursor: "pointer" }}
        >
          {showPin && ( // Conditionally render the pin
            <div className="pin">
              <div className="pin-value">
                {renderThumbContent ? renderThumbContent(index) : values[index]}
              </div>
            </div>
          )}
        </div>
      )}
    />
  );
};

YearRangeSlider.propTypes = {
  values: PropTypes.arrayOf(PropTypes.number).isRequired,
  step: PropTypes.number,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  renderThumbContent: PropTypes.func,
  showPin: PropTypes.bool, // Define prop type
};

YearRangeSlider.defaultProps = {
  step: 1,
  renderThumbContent: null,
  showPin: true, // Default to showing the pin
};

export default YearRangeSlider;
